import { adminRequestsTyped } from "@/api/(requests)/adminTyped";
import type { GetAllCsmResponse } from "@/core/types/(api)/csm";

export async function getCsmList(): Promise<GetAllCsmResponse> {
  return adminRequestsTyped.fetch_all_csm();
}
